<template>
  <div class="generalPage">
    <div class="isotopeGrid">

      <div class="section1">
        <div class="title_wrapper">
          <p class="title">
            預防螞蟻小貼士
          </p>
          <p class="subTitle">
            防止螞蟻的入侵
          </p>
        </div>
      </div>

      <div class="section2">
        <div class="generalWrapper">
          <h1>預防螞蟻小貼士</h1>
          <p>螞蟻是團結性很強的昆蟲，它們喜歡成群結隊的生活。如果看到有一隻螞蟻出現，代表家裡已經響起螞蟻的警號，要成功阻止螞蟻進入家中，就要從內外兩方面著手。</p>
          
          <h1>屋外</h1>
          <p>螞蟻入侵房屋可以是非常麻煩的一件事。如果不採取任何預防措施，螞蟻會迅速佔據您的家。要防止它們內進，請參考以下幾個貼士：</p>
          <ul>
            <li>若房屋內有盆栽或比較接近山坡草叢，請關緊門窗之間的縫隙和裂縫，以防止螞蟻從樹枝或樹葉爬到家中。</li>
            <li>枯萎和乾燥的植物往往是螞蟻所聚集的地方。請立即清除後院和其他戶外區域枯萎了的植物。</li>
          </ul>
          
          <h1>屋內</h1>
          <p>螞蟻需要食物、水、溫暖和安全，所以屋內家居對它們來說是完美的棲息地，但是，螞蟻聚集成穴會帶來很多麻煩。請參考以下幾個簡單貼士從家居著手，防止螞蟻入侵：</p>
          <ul>
            <li>食物是螞蟻的目標。請將所有食物保存在玻璃、塑料等密封的容器，以防止螞蟻的入侵。</li>
            <li>螞蟻經常在雪櫃底部找到它們喜歡的食物碎屑，請定期清潔雪櫃底部， 特別要掃走食物碎屑並把污跡擦乾淨。</li>
            <li>請使用有蓋垃圾桶及保持乾淨，並定期清理裡面的垃圾。</li>
          </ul>
        </div>
      </div>

      <div class="backbar_wrapper">
        <div class="backbar">
          <router-link :to="'/preventiontips/tips'">
            <img class="icon" src="../assets/icon-chevron.svg">
            <p>返回</p>
          </router-link>
        </div>
      </div>

    </div>
    <contact></contact>
    <henkel-footer></henkel-footer>
  </div>
</template>

<script>
export default {
  created () {
    window.document.title = '威滅Combat 速效藥餌'
    window.scrollTo(0, 0)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import "../styles/_vars.sass"
@import "../styles/_isotopeGrid.sass"

.generalPage
  padding-top: $topMenu-height

</style>



// WEBPACK FOOTER //
// PTipsTipsAnt.vue?56ca1d7c